import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import lgmMixin from '~/mixins/lgmMixin';
export default {

  data() {
    return {
      componentRendered: false,
      promotionBannerLoadedCount: 0,
    };
  },
  mixins: [eventTrackingMixins, lgmMixin],

  computed: {
  },
  created() {
  },
  mounted() {
    this.setEventTrackingListenersForFamilySite()
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeUpdate() {
  },
  updated() {
  },

  methods: {
    isLinkInProductSection(el) {
      const node = el.closest('.ComponentFamilyCampaignProductSection') || el.closest('.product-section') || el.closest('.happy-kids-home-page-product-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInStageSection(el) {
      const node = el.closest('.happy-kids-stage-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInBannerButton(el) {
      const node = el.closest('.promotion-banner-responsive-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInImageBanner(el) {
      const node = el.closest('.full-width-banner-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInTextSection(el) {
      const node = el.closest('.text-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInEventElement(el) {
      const node = el.closest('.event-element');
      if (node) {
        const eventAction = node?.getAttribute('data-event-action')
        const eventEntry = node?.getAttribute('data-event-entry')
        if (eventAction && eventEntry) {
          return true;
        }
      }
      return false;
    },


    setEventTrackingListenersForFamilySite() {
      this.listenerTasks.push(
        this.eventTrackingListenersForFamilySite,
        this.checkProductCardImpression
      );
    },

    checkProductCardImpression() {

      // delay 5sec to run the observer
      setTimeout(() => {
        // this.initProductCardObserver()

        const that = this
        const element = document.querySelectorAll('.ComponentFamilyCampaignProductSection .family-site-product-card-tracker, .happy-kids-home-page-product-section .family-site-product-card-tracker');
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let parent = entry.target.closest('.happy-kids-home-page-product-section .item');
                    if (!parent) {
                      parent = entry.target.closest('.ComponentFamilyCampaignProductSection .item');
                    }
                    const tracked = document.querySelector(`.item[id="${parent?.attributes["id"]?.value}"]`);
                    
                    if (tracked && !tracked.classList.contains('viewed')) {
                      that.handleEventTracking_familySiteProductCardVisible (parent?.attributes["data-insurer-code"]?.value, parent?.attributes["data-product-name"]?.value);
                      tracked.classList.add('viewed')
                    }
                }
            });
        });

        element.forEach(function(el) {
          observer.observe(el);
        });

      }, 2000);

    },


    eventTrackingListenersForFamilySite() {
      const item = document.querySelectorAll('.family-site a')
      if (item) {
        const self = this
        item.forEach(function (el) {
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')

            const dataFromClickableElement = self.extractDataFromClickedElement(el)
            const href = dataFromClickableElement?.href
            
            if (self.isLinkInEventElement(el)) {
              el.addEventListener('click', self.handleEventTracking_familySiteEventElement);
            } else {

              // #166 Product card CTA button click that leads to insurer website redirection
              if (self.isLinkInProductSection(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteProductSection);
              }
              // #233
              if (self.isLinkInStageSection(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteStageSection);
              }
              // #239a #238
              if (self.isLinkInInsurerSection(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteInsurerSection);
              }
                    
              // 289
              // A tag in .insurer-page-container .hero-section .floating-card
              if(self.isLinkInInsurerPageFloatingCard(el) || self.isLinkInInsurerDetailRemarkSection(el)){
                el.addEventListener('click', self.handleEventTracking_familySiteInsurerPageHeroSection);
                el.setAttribute('data-listener', 'true')
              }
  
              // #282 #283
              if (self.isLinkInFullWidthBannerSection(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteInsurerPageFullWidthBannerSection);
                el.setAttribute('data-listener', 'true')
              }
  
              // #284
              if (self.isLinkInTextSectionTable(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteTextSectionTable);
                // el.setAttribute('data-listener', 'true')
              }
  
              // #168 Textlink click that leads to insurer website redirection
              if (self.isLinkInTextSection(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteTextSection);
              }

              //  #285 #286 Family Site- Broker Enquiry Banner	Broker enquiry banner click
              if (self.isLinkInConsultationSection(el)) {
                el.addEventListener('click', self.handleEventTracking_familySiteConsultationSection);
              }
            }


          }
        });
      }
    },

    handleEventTracking_familySiteEventElement(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const eventTrackingParams = this.initEventTrackingParams()

      const eventElement = event.target.closest('.event-element')
      const eventAction = eventElement?.getAttribute('data-event-action')
      const eventEntry = eventElement?.getAttribute('data-event-entry')

      eventTrackingParams.a = eventAction
      eventTrackingParams.l = href
      eventTrackingParams.c = eventEntry

      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

    // #282 #283
    handleEventTracking_familySiteInsurerPageFullWidthBannerSection(event) {
     

      // // get the closest a tag of event.target
      const targetUrl = event.target.closest('a').href
      const regex = /https?:\/\/.*\/.*\/happy-kids-2024\/[^-]+-[^-]+-([^-]+)-?.+/;
      const match = targetUrl.match(regex);
      
      const insurerCode = match[1]
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const eventTrackingParams = this.initEventTrackingParams()

      // #282
      if (href.includes('certified-product-fwd-online')) {
        eventTrackingParams.a = 'to_insurer_digital_page'
        eventTrackingParams.l = dataFromClickedElement?.link_text
        eventTrackingParams.c = `certified_page_digitalbanner`
        eventTrackingParams.cd.product_category = undefined
        eventTrackingParams.cd.product_name = undefined
        eventTrackingParams.cd.insurer_name = insurerCode
      }

      // #283
      if (href.includes('certified-product-fwd-health-solution')) {
        eventTrackingParams.a = 'to_insurer_health_page'
        eventTrackingParams.l = dataFromClickedElement?.link_text
        eventTrackingParams.c = `certified_page_healthbanner`
        eventTrackingParams.cd.product_category = undefined
        eventTrackingParams.cd.product_name = undefined
        eventTrackingParams.cd.insurer_name = insurerCode
      }

      this.sendEventTracking(eventTrackingParams)
    },

    // #284
    handleEventTracking_familySiteTextSectionTable(event) {
      event.preventDefault();
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const eventTrackingParams = this.initEventTrackingParams()

      if (this.isTransitionLink(href)) {
        const linkText = dataFromClickedElement?.link_text

        const data = this.extractDataFromTransitionLink(href)
        eventTrackingParams.a = 'click_redirection'
        eventTrackingParams.l = linkText
        eventTrackingParams.c = `happykidscamp_${data.section}_${linkText}_${data.insurer}_product_table_${data.link}`
        eventTrackingParams.cd.product_category = `${data.category}`
        eventTrackingParams.cd.product_name = linkText
        eventTrackingParams.cd.insurer_name = `${data.insurer}`
      }

      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
      
      this.$goToURL(href, false, eventTrackingParams, {
        getLGMConversionId: this.getLGMConversionId,
        injectLGMConversionId: this.injectLGMConversionId,
        injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
      });
    },


    // #289
    handleEventTracking_familySiteInsurerPageHeroSection(event) {
      const currentUrl = window.location.href
      
      const regex = /https?:\/\/.*\/.*\/happy-kids-2024\/[^-]+-[^-]+-([^-]+)-?.+/;
      const match = currentUrl.match(regex);
      const insurerCode = match[1]

      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const eventTrackingParams = this.initEventTrackingParams()
      eventTrackingParams.a = 'to_happykids_methodology'
      eventTrackingParams.l = dataFromClickedElement?.link_text
      eventTrackingParams.c = `certified_page_hero_cta`
      eventTrackingParams.cd.product_category = undefined
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = insurerCode || undefined

      this.sendEventTracking(eventTrackingParams)
    },


    // #239a #238
    handleEventTracking_familySiteInsurerSection(event) {
      event.preventDefault();
      const eventTrackingParams = this.initEventTrackingParams();
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href;
      
      if (event.target.closest('.feature-card')) {
        // #238
        const insurerCode = event.target.closest('.feature-card').getAttribute('insurer-code')
        eventTrackingParams.a = 'to_insurer_page'
        eventTrackingParams.l = dataFromClickedElement?.link_text
        eventTrackingParams.c = `family_site_insurer_card`
        eventTrackingParams.cd.product_category = undefined
        eventTrackingParams.cd.product_name = undefined
        eventTrackingParams.cd.insurer_name = insurerCode
      } else {
        // #239a
        eventTrackingParams.a = 'to_happykids_methodology'
        eventTrackingParams.l = dataFromClickedElement?.link_text
        eventTrackingParams.c = `family_site_360banner_cta`
        eventTrackingParams.cd.product_category = undefined
        eventTrackingParams.cd.product_name = undefined
        eventTrackingParams.cd.insurer_name = undefined
      }

      this.sendEventTracking(eventTrackingParams)

      this.$goToURL(href, false, eventTrackingParams, {
        getLGMConversionId: this.getLGMConversionId,
        injectLGMConversionId: this.injectLGMConversionId,
        injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
      });
    },

    // #285 #286 Family Site- Broker Enquiry Banner	Broker enquiry banner click
    handleEventTracking_familySiteConsultationSection(event) {
      event.preventDefault();
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href

      // #285 check if is whatsapp link
      if (this.isWhatsappLink(href)) {
        const eventTrackingParams = this.initEventTrackingParams()

        eventTrackingParams.a = 'open_whatsapp'
        eventTrackingParams.l = dataFromClickedElement?.link_text
        eventTrackingParams.c = `happykidscamp_whatsapp`
        eventTrackingParams.cd.product_category = undefined
        eventTrackingParams.cd.product_name = undefined
        eventTrackingParams.cd.insurer_name = undefined

        this.sendEventTracking(eventTrackingParams)

        this.$goToURL(href, false, eventTrackingParams, {
          getLGMConversionId: this.getLGMConversionId,
          injectLGMConversionId: this.injectLGMConversionId,
          injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
        });
      }
      // #286 check if the href contans "connect.10life.com" or "10lifeconnect"
      if (this.is10LifeConnectLink(href)) {
        const eventTrackingParams = this.initEventTrackingParams()

        eventTrackingParams.a = 'go_to_connect'
        eventTrackingParams.l = dataFromClickedElement?.link_text
        eventTrackingParams.c = `happykidscamp_connect_cta`
        eventTrackingParams.cd.product_category = undefined
        eventTrackingParams.cd.product_name = undefined
        eventTrackingParams.cd.insurer_name = undefined

        this.sendEventTracking(eventTrackingParams)
        
        this.$goToURL(href, false, eventTrackingParams, {
          getLGMConversionId: this.getLGMConversionId,
          injectLGMConversionId: this.injectLGMConversionId,
          injectLGMConversionIdToEComSite: this.injectLGMConversionIdToEComSite
        });
      }

    },

    // #234 the insurer product card impression. ad_impression family_site_product_card
    handleEventTracking_familySiteProductCardVisible(insurerCode, productName) {
      const eventTrackingParams = this.initEventTrackingParams()
      eventTrackingParams.a = 'ad_impression'
      eventTrackingParams.l = `${productName}`
      eventTrackingParams.c = `family_site_product_card`
      eventTrackingParams.cd.product_category = ``
      eventTrackingParams.cd.product_name = productName
      eventTrackingParams.cd.insurer_name = `${insurerCode}`
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

    getTrackingDataFromProductSection(event) {
      const aTag = event?.target?.closest('a');
      // get closest parent with class of '.item'
      const cardItem = aTag?.closest('.item');
      // get section and category from sectionItem.
      let sectionItem = cardItem?.closest('.happy-kids-home-page-product-section');
      if (!sectionItem) {
        sectionItem = cardItem?.closest('.ComponentFamilyCampaignProductSection');
      }

      let sectionText = '';
      if (sectionItem && sectionItem.querySelector('h2')) {
        sectionText = sectionItem.querySelector('h2').innerText;
      }
      let categoryText = '';
      if (sectionItem && sectionItem.querySelector('.active')) {
        categoryText = sectionItem.querySelector('.active').innerText;
      }

      const section = sectionText;
      const category = categoryText;
      const insurer = cardItem?.getAttribute('data-insurer-code');
      const cardCategory = category;
      const cardTitle = cardItem?.getAttribute('data-product-name');
      const cardHref = aTag?.getAttribute('href');
      const cardLinkText = aTag?.innerText;
      return {
        section,
        category,
        insurer,
        product_name: cardTitle,
        href: cardHref,
        link_text: cardLinkText,
        link_node: aTag,
      }
    },

    handleEventTracking_familySiteStageSection(event) {
      // #233
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const eventTrackingParams = this.initEventTrackingParams()

      const linkText = dataFromClickedElement?.link_text

      eventTrackingParams.a = 'to_persona_page'
      eventTrackingParams.l = linkText
      eventTrackingParams.c = `persona_banner_cta`
      eventTrackingParams.cd.product_category = `${dataFromClickedElement.category}`
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${dataFromClickedElement.insurer}`

      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

    handleEventTracking_familySiteProductSection(event) {
      event.preventDefault();
      // stop the default action of the event.

      // no bubble up to parent element.
      event.stopPropagation();

      // no pass to children element.
      event.stopImmediatePropagation();

      let selector;
      if (event.target.closest('.happy-kids-home-page-product-section .item') !== null) {
        selector = '.happy-kids-home-page-product-section .item'
      } else {
        selector = '.ComponentFamilyCampaignProductSection .item'
      }

      const productSectionData = this.getTrackingDataFromProductSection(event)
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target, selector)
      const href = dataFromClickedElement?.href
      const eventTrackingParams = this.initEventTrackingParams()

      if (dataFromClickedElement?.link_node.classList.contains('product-card-cta-link')) {
        
        // #166 click_redirection
        // happykidscamp_{section}_{category}_{insurer name}_products_card_{hyperlink}
        if (this.isTransitionLink(href)) {
          event.preventDefault();
          const linkText = dataFromClickedElement?.link_text

          const data = this.extractDataFromTransitionLink(href)
          eventTrackingParams.a = 'click_redirection'
          eventTrackingParams.l = linkText
          eventTrackingParams.c = `happykidscamp_${data.section}_${data.category}_${data.insurer}_products_card_${data.link}`
          eventTrackingParams.cd.product_category = `${data.category || productSectionData.category}`
          eventTrackingParams.cd.product_name = productSectionData.product_name
          eventTrackingParams.cd.insurer_name = `${data.insurer || productSectionData.insurer}`
        }
        
        // #235a Family Site, Product Card - the action leads to open whatsapp
        if (this.isWhatsappLink(href)) {

          const data = this.extractDataFromTransitionLink(href)
          eventTrackingParams.a = 'open_whatsapp'
          eventTrackingParams.l = dataFromClickedElement?.link_text
          eventTrackingParams.c = `family_site_product_card_cta`
          eventTrackingParams.cd.product_category = `${data.category || productSectionData.category}`
          eventTrackingParams.cd.product_name = productSectionData.product_name
          eventTrackingParams.cd.insurer_name = `${data.insurer || productSectionData.insurer}`
        }

        // #244 the action leads to decoder product details page.
        if (this.isProductDetailLink(href)) {
          const linkText = dataFromClickedElement?.link_text

          eventTrackingParams.a = 'open_product_details'
          eventTrackingParams.l = linkText
          eventTrackingParams.c = `family_site_product_card_cta`
          eventTrackingParams.cd.product_category = `${dataFromClickedElement.card_category}`
          eventTrackingParams.cd.product_name = `${dataFromClickedElement.card_title}`
          eventTrackingParams.cd.insurer_name = `${dataFromClickedElement.insurer_name}`
        }
      }

   
      // check if the dataFromClickedElement?.link_node has class of product-card-cta-link.
      // console.debug('dataFromClickedElement?.link_node.classList:' ,dataFromClickedElement?.link_node.classList);

      if (dataFromClickedElement?.link_node.classList.contains('tooltip-cta')) {
        
        const productSectionData = this.getTrackingDataFromProductSection(event)
        const category = productSectionData.category;
        const insurer = productSectionData.insurer;
        const cardTitle = productSectionData.product_name;

        // #243 tooltip-cta
        if (this.isTransitionLink(href)) {
          const linkText = dataFromClickedElement?.link_text

          const data = this.extractDataFromTransitionLink(href)
          eventTrackingParams.a = 'click_redirection'
          eventTrackingParams.l = linkText
          eventTrackingParams.c = `happykidscamp_${data.section}_${data.category}_${data.insurer}_products_card_promo_${data.link}`
          eventTrackingParams.cd.product_category = `${dataFromClickedElement.card_category || category}`
          eventTrackingParams.cd.product_name = `${dataFromClickedElement.card_title || cardTitle}`
          eventTrackingParams.cd.insurer_name = `${dataFromClickedElement.insurer_name || insurer}`
        } else {
          
          // #287 btn-popup
          if (dataFromClickedElement?.link_node.classList.contains('btn-popup')) {
            // const linkText = dataFromClickedElement?.link_text
  
            // const data = this.extractDataFromTransitionLink(href)
            eventTrackingParams.a = 'open_promo_details'
            eventTrackingParams.l = `${dataFromClickedElement.insurer_name}+${dataFromClickedElement.card_title}`
            eventTrackingParams.c = `family_site_products_promo_banner`
            eventTrackingParams.cd.product_category = `${dataFromClickedElement.card_category || category}`
            eventTrackingParams.cd.product_name = `${dataFromClickedElement.card_title || cardTitle}`
            eventTrackingParams.cd.insurer_name = `${dataFromClickedElement.insurer_name || insurer}`
          }
        }
      }

      if (dataFromClickedElement?.link_node.classList.contains('product-tag')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const productSectionData = this.getTrackingDataFromProductSection(event)
        const category = productSectionData.category;
        const insurer = productSectionData.insurer;
        const cardTitle = productSectionData.product_name;



        // #236 feature tag high cp
        if (dataFromClickedElement?.link_node.querySelector('.label-item-text')?.innerText === '高性價比') {
          const linkText = dataFromClickedElement?.link_text

          eventTrackingParams.a = 'to_happykids_methodology'
          eventTrackingParams.l = linkText
          eventTrackingParams.c = `family_site_product_card_cp_value`
          eventTrackingParams.cd.product_category = `${category}`
          eventTrackingParams.cd.product_name = `${cardTitle}`
          eventTrackingParams.cd.insurer_name = `${insurer}`
        }
        if (dataFromClickedElement?.link_node.querySelector('.label-item-text')?.innerText === '高保障') {
          // #237 feature tag high-coverage
          const linkText = dataFromClickedElement?.link_text

          eventTrackingParams.a = 'to_happykids_methodology'
          eventTrackingParams.l = linkText
          eventTrackingParams.c = `family_site_product_card_high_coverage`
          eventTrackingParams.cd.product_category = `${category}`
          eventTrackingParams.cd.product_name = `${cardTitle}`
          eventTrackingParams.cd.insurer_name = `${insurer}`
        }
      }

      // #235 click cta and redirect to certified product page.
      if (this.isFamilySiteProductPageLink(href)) {
        const linkText = dataFromClickedElement?.link_text

        eventTrackingParams.a = 'to_certifiedproductpage'
        eventTrackingParams.l = linkText
        eventTrackingParams.c = `family_site_product_card_cta`
        eventTrackingParams.cd.product_category = `${dataFromClickedElement.card_category}`
        eventTrackingParams.cd.product_name = `${dataFromClickedElement.card_title}`
        eventTrackingParams.cd.insurer_name = `${dataFromClickedElement.insurer_name}`
      }


      this.$goToURL(href, false, eventTrackingParams, {
        getLGMConversionId: this.getLGMConversionId,
        injectLGMConversionId: this.injectLGMConversionId
      }); 

      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }

    },

    // #167 click_redirection
    // happykidscamp_{category}_{insurer name}_banner_cta_{hyperlink}
    handleEventTracking_familySiteBannerButton(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const linkText = dataFromClickedElement?.link_text
      const eventTrackingParams = this.initEventTrackingParams()

      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = linkText
      eventTrackingParams.c = `happykidscamp_${data.category}_${data.insurer}_banner_cta_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${data.insurer}`

      if(eventTrackingParams.a !== ''){
        window.eventTracking(eventTrackingParams)
      }
    },

    // #168 click_redirection
    // happykidscamp_{category}_{insurer name}_hyperlink_{hyperlink}
    handleEventTracking_familySiteTextSection(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const linkText = dataFromClickedElement?.link_text
      const eventTrackingParams = this.initEventTrackingParams()

      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = linkText
      eventTrackingParams.c = `happykidscamp_${data.category}_${data.insurer}_hyperlink_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${data.insurer}`

      if(eventTrackingParams.a !== ''){
        window.eventTracking(eventTrackingParams)
      }
    },

    // #169 click_redirection
    // happykidscamp_{category}_{insurer name}_image_{hyperlink}
    handleEventTracking_familySiteImageBanner(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)
      const href = dataFromClickedElement?.href
      const imgPath = dataFromClickedElement?.image_path
      const eventTrackingParams = this.initEventTrackingParams()

      const data = this.extractDataFromTransitionLink(href)
      eventTrackingParams.a = 'click_redirection'
      eventTrackingParams.l = imgPath
      eventTrackingParams.c = `happykidscamp_${data.category}_${data.insurer}_image_${data.link}`
      eventTrackingParams.cd.product_category = `${data.category}`
      eventTrackingParams.cd.product_name = undefined
      eventTrackingParams.cd.insurer_name = `${data.insurer}`

      if(eventTrackingParams.a !== ''){
        window.eventTracking(eventTrackingParams)
      }
    },

    isFamilySiteProductPageLink(link) {
      const href = link;
      if (!href) return false;

      const patternProducts = /^.*\/([a-zA-Z0-9%\-]+)-product-([a-zA-Z0-9%\-]+)$/;
      if (href.match(patternProducts)) {
        return true;
      }
      return false;
    },
    isLinkInConsultationSection(el) {
      const node = el.closest('.consultation-section-component');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInInsurerSection(el) { 
      // aka 360 section
      const node = el.closest('.happy-kids-home-insurer-section');
      if (node) {
        return true;
      }
      return false;
    },
    isLinkInModalContent(el) { 
      
      const node = el.closest('.modal-promotion-content');
      if (node) {
        return true;
      }
      return false;
    },
    
    // check if the link contains "connect.10life.com" or "10lifeconnect"
    is10LifeConnectLink(href) {
      if (href.includes('connect.10life.com') || href.includes('10lifeconnect')) {
        return true;
      }
      return false;
    },
    
    // check if the clicked el is in .insurer-page-container .hero-section .floating-card
    isLinkInInsurerPageFloatingCard(el) {
      const node = el.closest('.insurer-page-container .hero-section .floating-card');
      if (node) {
        return true;
      }
      return false;
    },
    // check if the link is in '.happy-kids-insurer-detail .insurer-head .remark'
    isLinkInInsurerDetailRemarkSection(el) {
      const node = el.closest('.happy-kids-insurer-detail .insurer-head .remark');
      if (node) {
        return true;
      }
      return false;
    },

    // check if the link is in '.insurer-page-container .ComponentFamilyCampaignFullWidthBannerSection'
    isLinkInFullWidthBannerSection(el) {
      const node = el.closest('.insurer-page-container .ComponentFamilyCampaignFullWidthBannerSection');
      if (node) {
        return true;
      }
      return false;
    },

    // check if the link is in '.insurer-page-container .ComponentFamilyCampaignTextSection table'
    isLinkInTextSectionTable(el) {
      const node = el.closest('.happy-kids-insurer-detail .ComponentFamilyCampaignTextSection table');
      if (node) {
        return true;
      }
      return false;
    },



  },

  watch: {
  }
};
